
const transition = async (duration) => {
  return new Promise(resolve => {
    window.setTimeout(() => resolve(), duration);
  })
}



document.querySelectorAll('[data-projects]').forEach(projectList => {

  const baseUrl = projectList.dataset.projects;

  const restUrl = window.php_vars.restUrl;
  const endpoint = `${restUrl}glunz/v1/detail/`;

  const tagFilterElements = projectList.querySelectorAll('[data-filter]');
  const tagFilters = [];

  const projectElements = projectList.querySelectorAll('[data-project]');
  const projects = [];

  tagFilterElements.forEach(filter => {
    tagFilters.push({
      element: filter,
      value: filter.dataset.filter,
      active: false
    })
  });

  projectElements.forEach(project => {
    projects.push({
      element: project,
      placeholder: project.querySelector('[data-placeholder]'),
      tags: project.dataset.tags.split(',').map(tag => tag.trim()),
      trigger: project.querySelector('[data-project-link]'),
      detailActive: project.classList.contains('is-active'),
      anchor: project.querySelector('[data-anchor]'),
      active: true,
      slug: project.dataset.slug,
      isLoading: false
    })
  });

  const updateUrl = () => {
    // update state. baseurl / project-slug-if-active ? tag=tag-slug-if-active:
    const activeProject = projects.find(project => project.detailActive);
    const activeFilter = tagFilters.find(filter => filter.active);

    let url = baseUrl;
    if (activeProject) {
      url += `${activeProject.slug}`;
    }
    if (activeFilter) {
      url += `?tag=${activeFilter.value}`;
    }
    window.history.pushState({}, '', url);
  }


  const updateList = () => {
    const activeFilter = tagFilters.find(filter => filter.active);
    projects.forEach(project => {
      if (project.active) {
        closeProjectDetail(project);
      }


      if (!activeFilter || project.tags.includes(activeFilter.value)) {
        project.element.classList.remove('is-hidden');
        project.active = true;
      } else {
        project.element.classList.add('is-hidden');
        project.active = false;
      }
      updateUrl();
    });
  }

  tagFilters.forEach(filter => {
    filter.element.addEventListener('click', (e) => {
      e.preventDefault();
      tagFilters.forEach(f => {
        if (f === filter) {
          f.active = !f.active;
          f.element.classList.toggle('is-active', f.active);
        } else {
          f.active = false;
          f.element.classList.remove('is-active');
        }
      });
      updateList();
      updateUrl();
    })
  });




  const loadProjectDetail = async (project) => {

    let detailsElement = project.element.querySelector('[data-detail]');

    if (!detailsElement) {
      const response = await fetch(`${endpoint}${project.trigger.dataset.id}`);
      const data = await response.json();

      const detailElement = document.createElement('div');
      detailElement.dataset.detail = '';
      detailElement.innerHTML = data.html;

      const closeButton = detailElement.querySelector('[data-close-project]');
      closeButton.addEventListener('click', async (e) => {
        await closeProjectDetail(project);
      });

      project.placeholder.appendChild(detailElement);
      detailsElement = detailElement;
    }
    const rect = detailsElement.getBoundingClientRect();

    const placeholderHeight = rect.height;
    project.element.style.setProperty('--placeholder-max-height', `${placeholderHeight}px`);

    project.detailActive = true;
    project.element.classList.add('is-active');

    // Now that the accordion is opening and the slider has real dimensions,
    // ask slider.js to (re)initialise / update.
    window.dispatchEvent(new CustomEvent('init:sliders'));
  }

  const closeProjectDetail = async (project) => {
    project.element.classList.remove('is-active');
    project.element.style.setProperty('--placeholder-max-height', `0px`);
    project.detailActive = false;
  }

  projects.forEach(project => {

    // preload url on hover:
    project.trigger.addEventListener('mouseenter', async () => {
      if (project.element.querySelector('[data-detail]')) return;

      project.isLoading = true;

      const response = await fetch(`${endpoint}${project.trigger.dataset.id}`);
      const data = await response.json();

      const detailElement = document.createElement('div');
      detailElement.dataset.detail = '';
      detailElement.innerHTML = data.html;

      const closeButton = detailElement.querySelector('[data-close-project]');
      closeButton.addEventListener('click', async (e) => {
        await closeProjectDetail(project);
      });

      project.placeholder.appendChild(detailElement);
      project.isLoading = false;
    });


    project.trigger.addEventListener('click', async (e) => {
      if (e.metaKey || e.ctrlKey) return;

      e.preventDefault();

      if (project.detailActive) {
        await closeProjectDetail(project);
      } else {
        await loadProjectDetail(project);
      }

      updateUrl();
    });
  })



  const initialOpenProject = projects.find(project => project.element.classList.contains('is-active'));
  if (initialOpenProject) {
    const detailElement = initialOpenProject.element.querySelector('[data-detail]');
    if (detailElement) {
      const rect = detailElement.getBoundingClientRect();
      const placeholderHeight = rect.height;
      initialOpenProject.element.style.setProperty('--placeholder-max-height', `${placeholderHeight}px`);

      // Land on the project anchor immediately; re-snap once the page (lazy
      // images, fonts, accordion transition) has finished settling so any
      // layout shift after the initial scroll doesn't leave us elsewhere.
      const scrollToAnchor = () => {
        initialOpenProject.anchor.scrollIntoView({ block: 'start', inline: 'nearest' });
      };
      scrollToAnchor();
      if (document.readyState !== 'complete') {
        window.addEventListener('load', scrollToAnchor, { once: true });
      }

      const closeButton = detailElement.querySelector('[data-close-project]');
      closeButton.addEventListener('click', async (e) => {
        await closeProjectDetail(initialOpenProject);
      });
    }
  }

  //check if url has tag query param and activate filter:
  const urlParams = new URLSearchParams(window.location.search);
  const tagParam = urlParams.get('tag');
  if (tagParam) {
    const filterToActivate = tagFilters.find(filter => filter.value === tagParam);
    if (filterToActivate) {
      filterToActivate.active = true;
      filterToActivate.element.classList.add('is-active');
      updateList();
    }
  }


});
